
$( function() {
    document.querySelectorAll( '[data-slider]' ).forEach( slider => {
        const parent = slider.parentElement;
        $( slider ).slick( {
            slidesToShow: 1,
            mobileFirst: true,
            infinite: false,
            speed: 600,
            arrows: true,
            nextArrow: parent.querySelector( '.slick-next' ),
            prevArrow: parent.querySelector( '.slick-prev' ),
            responsive: [
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                    }
                }
            ]
        } )
    } );
})